import * as tslib_1 from "tslib";
import { Router, ActivatedRoute } from '@angular/router';
import { AlertController, Platform } from '@ionic/angular';
import { RequestsType } from '../model/appConfig';
import { User } from '../model/user.model';
import { AppService } from '../services/app.service';
import { AuthService } from '../services/auth.service';
import { PlayerService } from '../services/player.service';
import { SignalRService } from '../services/signalr.service';
var LoginComponent = /** @class */ (function () {
    function LoginComponent(authService, playerService, router, appService, route, alertController, platform, signalRService) {
        var _this = this;
        this.authService = authService;
        this.playerService = playerService;
        this.router = router;
        this.appService = appService;
        this.route = route;
        this.alertController = alertController;
        this.platform = platform;
        this.signalRService = signalRService;
        this.name = "";
        this.password = "";
        this.error = "";
        this.children = [];
        this.route.params.subscribe(function (p) {
            _this.name = _this.authService.prevUser.name;
            _this.password = _this.authService.prevUser.password;
        });
    }
    LoginComponent.prototype.login = function (isChildUser) {
        var _this = this;
        this.name = this.name.trim().toLocaleLowerCase();
        this.password = this.password.trim().toLocaleLowerCase();
        var errorMsg = "\u05D4\u05D0\u05E4\u05DC\u05D9\u05E7\u05E6\u05D9\u05D9\u05D4 \u05DC\u05D0 \u05DE\u05E6\u05DC\u05D9\u05D7\u05D4 \u05DC\u05D4\u05EA\u05D7\u05D1\u05E8 \u05DC\u05E0\u05D2\u05DF-\u05DE\u05D7\u05E9\u05D1, \u05E0\u05D0 \u05DC\u05D1\u05D3\u05D5\u05E7:\n            <ol>\n                <li>\u05E9\u05D4\u05E7\u05DC\u05D3\u05EA \u05D0\u05EA \u05D4\u05D9\u05D5\u05D6\u05E8 \u05D5\u05D4\u05E1\u05D9\u05E1\u05DE\u05D4 \u05E0\u05DB\u05D5\u05DF.</li>\n                <li>\u05E9\u05D4\u05DE\u05D7\u05E9\u05D1 \u05DE\u05D7\u05D5\u05D1\u05E8 \u05DC\u05D0\u05D9\u05E0\u05D8\u05E8\u05E0\u05D8 - \u05DC\u05D5\u05D5\u05D3\u05D0 \u05E9\u05DB\u05DC \u05D4\u05DB\u05D1\u05DC\u05D9\u05DD \u05DE\u05D7\u05D5\u05D1\u05E8\u05D9\u05DD \u05DB\u05E8\u05D0\u05D5\u05D9 \u05DC\u05E0\u05D2\u05DF-\u05DE\u05D7\u05E9\u05D1 \u05D5\u05DC\u05DB\u05D1\u05D5\u05EA \u05D5\u05DC\u05D4\u05D3\u05DC\u05D9\u05E7 \u05D0\u05D5\u05EA\u05D5, \u05D5\u05DC\u05D7\u05DB\u05D5\u05EA \u05D3\u05E7\u05D4 \u05DC\u05D0\u05D7\u05E8 \u05DE\u05DB\u05DF \u05D5\u05DC\u05D1\u05D3\u05D5\u05E7 \u05E9\u05D5\u05D1 \u05D0\u05DD \u05D4\u05EA\u05E7\u05DC\u05D4 \u05E0\u05E4\u05EA\u05E8\u05D4.</li>\n            </ol>\n            \u05D1\u05DE\u05D9\u05D3\u05D4 \u05D5\u05D4\u05EA\u05E7\u05DC\u05D4 \u05E2\u05D3\u05D9\u05D9\u05DF \u05DC\u05D0 \u05E0\u05E4\u05EA\u05E8\u05D4 - \u05D0\u05E0\u05D0 \u05E6\u05E8\u05D5 \u05E7\u05E9\u05E8 \u05E2\u05DD \u05E9\u05D9\u05E8\u05D5\u05EA \u05D4\u05DC\u05E7\u05D5\u05D7\u05D5\u05EA \u05E9\u05DC\u05E0\u05D5 \u05D3\u05E8\u05DA \u05D4\u05D5\u05D5\u05D8\u05E1\u05D0\u05E4 \u05D1\u05DC\u05D9\u05E0\u05E7 \u05DC\u05DE\u05D8\u05D4.";
        if (this.name.length && this.password.length) {
            this.appService.loading = "active";
            this.authService.authenticate(this.name, this.password).subscribe(function (res) {
                if (res.errorCode === "0") {
                    var permissions_1 = {
                        canControlSchedulerSwitch: _this.toOptionalBool(res.canControlSchedulerSwitch),
                        canEditWeeklyScheduler: _this.toOptionalBool(res.canEditWeeklyScheduler),
                        canEditSpecialDates: _this.toOptionalBool(res.canEditSpecialDates),
                    };
                    _this.error = "";
                    _this.authService.getChildUsers(_this.name, _this.password).subscribe(function (res2) {
                        _this.children = res2.filter(function (u) { return u.User !== _this.name; }).map(function (u) { return new User(u.User, u.Password, u.NickName, u.Active); }).sort();
                        _this.authService.saveAuthData(_this.name, _this.password, _this.children, isChildUser, permissions_1);
                        if (_this.children.length > 0) {
                            _this.router.navigateByUrl("/auth/cabinet");
                        }
                        if (!res2.find(function (x) { return x.User === _this.name; }).Active) {
                            _this.appService.loading = "";
                        }
                        else {
                            _this.checkSignalRAndAuth();
                        }
                    }, function (err) {
                        _this.appService.loading = "";
                        _this.error = errorMsg + " | getChildUsers";
                    });
                }
                else {
                    _this.appService.loading = "";
                    _this.error = errorMsg;
                }
            }, function (err) {
                _this.appService.loading = "";
                _this.error = errorMsg + " | authenticate";
            });
        }
    };
    LoginComponent.prototype.toOptionalBool = function (value) {
        if (value === undefined || value === null) {
            return undefined;
        }
        return !!value;
    };
    LoginComponent.prototype.checkSignalRAndAuth = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var config, error_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.appService.getConfig()];
                    case 1:
                        config = _a.sent();
                        if (config.requestsType === RequestsType.SignalR) {
                            this.signalRService.startConnection(this.authService.currentUser.name)
                                .then(function () {
                                console.log('SignalR Connection started');
                                _this.afterAuth();
                            })
                                .catch(function (err) { return console.error('Error establishing SignalR connection: ' + err); });
                        }
                        else {
                            this.afterAuth();
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error('Failed to get config during login:', error_1);
                        // Fallback to HTTP mode
                        this.afterAuth();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LoginComponent.prototype.afterAuth = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.appService.loadConfig()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.playerService.start()];
                    case 2:
                        _a.sent();
                        this.appService.loading = "";
                        this.router.navigateByUrl("/");
                        return [2 /*return*/];
                }
            });
        });
    };
    LoginComponent.prototype.setCurrentUser = function (newUser) {
        if (newUser.name !== this.name && newUser.active) {
            this.name = newUser.name;
            this.password = newUser.password;
            this.login(true);
        }
    };
    LoginComponent.prototype.getUserClass = function (user) {
        if (this.name === user.name) {
            return "active";
        }
        else if (!user.active) {
            return "disabled";
        }
        else {
            return "";
        }
    };
    LoginComponent.prototype.logout = function () {
        this.children = [];
    };
    // Just to check if mobile app was updated. Can delete later
    LoginComponent.prototype.testPopup = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var alert;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.alertController.create({
                            header: "Test popup",
                            message: "3.10.29" + (" | android: " + this.platform.is("android") + ", ios: " + this.platform.is("ios") + ", cordova: " + this.platform.is("cordova")),
                            buttons: ['OK'],
                        })];
                    case 1:
                        alert = _a.sent();
                        return [4 /*yield*/, alert.present()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return LoginComponent;
}());
export { LoginComponent };
